<template>
    <v-app>
        <app-navbar />
        <app-main />
    </v-app>
</template>

<script>
const loadComponent = (componentName) => {
    return () => import(`@/components/${componentName}`);
};

export default {
    data: () => ({}),
    methods: {},
    components: {
        appNavbar: loadComponent("navbar"),
        appMain: loadComponent("main"),
    },
    mounted() {
        setTimeout(() => {
            if (this.$store.getters["website/isLoading"])
                this.$store.dispatch("setWebsiteLoading");
        }, 1000);
    },
};
</script>
